export const agencies = [
    {},
    [
        {
            name: "hermosillo",
            location: "https://g.page/SuzukiHermosillo?share",
        },
        {
            name: "obregon",
            location: "https://goo.gl/maps/ryYDwwEQNwbEW6mBA",
        },
        {
            name: "gdl country",
            location: "https://goo.gl/maps/3NcMWLx77VNem39J8",
        },
        {
            name: "gdl gonzalez gallo",
            location: "https://goo.gl/maps/FTDKDZjUp4K5BnQW6",
        },
        {
           name: "gdl santa anita",
            location: "https://goo.gl/maps/xoS33QrVoF1HhG729",
        },
    ],
    [
        {
            name: "hermosillo",
            location: "https://g.page/JACHERMOSILLO?share",
        },
        {
            name: "guadalajara",
            location: "https://goo.gl/maps/P5XhyWgK9mkTC82G6",
        },
        {
            name: "galerias",
            location: "https://goo.gl/maps/AVYYDhUiPbv56CFC7",
        },
        {
            name: "puerto vallarta",
            location: "https://gruposolana.com/new/grupo-solana/public/agencias",
        },
    ],
    [
        {
            name: "hermosillo",
            location: "https://goo.gl/maps/RNBDoyu1rpu5sS8SA",
        },
        {
            name: "guadalajara",
            location: "https://g.page/IsuzuGuadalajara?share",
        },
    ],
    [
        {
            name: "hermosillo",
            location: "https://goo.gl/maps/1C5zRd4hRfbTerZN9",
        },
        {
            name: "gonzalez gallo",
            location: "https://goo.gl/maps/P8NubHhQR6RBxQWUA",
        },
        {
            name: "cajeme",
            location: "https://g.page/HyundaiObregon?share",
        },
        {
            name: "morelia",
            location: "https://g.page/HyundaiSolanaMoreliaCamelinas?share",
        },
        {
            name: "uruapan",
            location: "https://goo.gl/maps/6uaMLeyzhidfEcjj8",
        },
    ],
    [
        {
            name: "hermosillo",
            location: "https://g.page/VolkswagenSolanaHermosillo?share",
        },
    ],
    [
        {
            name: "cdmx",
            location: "https://goo.gl/maps/FFAJL9emzJet1bgu7",
        },
    ],
    [
        {
            name: "hermosillo reforma",
            location: "https://goo.gl/maps/NPs88StULPNKTucL6",
        },
        {
            name: "hermosillo morelos",
            location: "https://g.page/Seminuevos-toyota-solana-morelos?share",
        },
        {
            name: "cd. obregón",
            location: "https://g.page/ToyotaObregon?share",
        },
        {
            name: "nogales",
            location: "https://goo.gl/maps/SdcziE5hEd6v9W7p8",
        },
        {
            name: "cdmx",
            location: "https://g.page/Seminuevostoyotainterlomas?share",
        },
    ],
    [],
    [],
    [],
];

export const agenciesNames = [
    "",
    "Susuki",
    "Jac",
    "Isuzu",
    "Hyundai",
    "Volkswagen",
    "Kia",
    "Toyota",
    "",
    "",
    "",
];